import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, input, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';

import { ClientService } from '../../../../services/client-service';
import { IConsent, IConsentType, IDiyaClient } from '../../../../models/client';

import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import
  {
    MatDialog,
    MAT_DIALOG_DATA,
    MatDialogTitle,
    MatDialogContent,
    MatDialogModule,
  } from '@angular/material/dialog';

@Component( {
  selector: 'app-diya-health-component',
  imports: [
    DatePipe,
    MatButtonModule,
    MatCardModule,
    MatPaginator,
    MatPaginatorModule,
    MatIcon,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDialogModule,
  ],
  templateUrl: './diya-health-component.html',
  styleUrl: './diya-health-component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
} )
export class DiyaHealthComponent implements OnInit, AfterViewInit
{
  constructor(
    private _clientService: ClientService,
    private _cdr: ChangeDetectorRef,
  ) { }

  public clientId = input.required<string>();
  public legend = 'PHR';

  public client: IDiyaClient | undefined | null;
  public dataSource = new MatTableDataSource<IConsent>( [] );
  public consents: IConsent[] | undefined;
  public consentTypes: IConsentType[] = [];
  public selectedConsentType: string = '';
  public notConfigured: boolean = false;
  public dialog = inject( MatDialog );

  protected length = 0;
  protected pageIndex = 0;
  protected pageSizeOptions = [12, 24, 50, 100];

  @ViewChild( MatPaginator ) paginator!: MatPaginator;

  ngOnInit(): void
  {
    
  }

  async ngAfterViewInit(): Promise<void>
  {
    await this.getData();
    this.consentTypes = await this._clientService.getDiyaConsentTypes( this.clientId() ) || [];
    this.selectedConsentType = this.consentTypes.length > 0 ? this.consentTypes[0].id : '';
    this._cdr.detectChanges();
  }

  async getData()
  {
    this.client = await this._clientService.getDiyaClient( this.clientId() );
    if ( !this.client )
    {
      this.notConfigured = true;
      return;
    }

    this.dataSource.data = this.client.consents.items;
    this.dataSource.paginator = this.paginator;
    this.consents = this.dataSource._pageData( this.dataSource.data );
  }

  pageChanged( event: PageEvent )
  {
    this.pageIndex = event.pageIndex;
    this.consents = this.dataSource._pageData( this.dataSource.data );
  }

  applyFilter( event: Event )
  {
    const filterValue = ( event.target as HTMLInputElement ).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if ( this.dataSource.paginator )
    {
      this.consents = this.dataSource._pageData( this.dataSource.filteredData );
      this.dataSource.paginator.firstPage();
    }
  }

  async openDocument( documentId: string )
  {
    const file = await this._clientService.getDiyaFile( this.clientId(), documentId );
    const url = URL.createObjectURL( file!  );
    window.open( url, '_blank' );
  }

  OpenConfirmDialog()
  {
    const consentType = this.consentTypes.find( ct => ct.id === this.selectedConsentType );
    if ( !consentType ) return;

    const dialogRef = this.dialog.open( DiyaHealthConsentConfirmDialog, {
      data: {
        consentType: consentType?.name,
      },
    } );

    dialogRef.afterClosed().subscribe( result =>
    {
      if ( result )
      {
        this.sendConsent();
      }
    } );
  }

  async sendConsent()
  {
    await this._clientService.createDiyaConsent( this.clientId(), this.selectedConsentType );
    await this.getData();
  }

  async addClient()
  {
    const result = await this._clientService.createDiyaClient( this.clientId() );
    this.client = result;
    this._cdr.detectChanges();
  }

}

@Component( {
  selector: 'diya-health-consent-confirm-dialog',
  templateUrl: 'diya-health-consent-confirm-dialog.html',
  imports: [MatDialogTitle, MatDialogContent, MatDialogModule, MatButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
} )
export class DiyaHealthConsentConfirmDialog
{
  data = inject( MAT_DIALOG_DATA );
}
